import React from 'react';
import { ShoppingCart, DollarSign, TrendingUp, Users, AlertTriangle, Package, Clock } from 'lucide-react';
import { StatCard } from '../../components/admin/StatCard';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
const revenueData = [{
  name: 'Sen',
  value: 4500000
}, {
  name: 'Sel',
  value: 5200000
}, {
  name: 'Rab',
  value: 4800000
}, {
  name: 'Kam',
  value: 6100000
}, {
  name: 'Jum',
  value: 5900000
}, {
  name: 'Sab',
  value: 7200000
}, {
  name: 'Min',
  value: 6800000
}];
const topCooperatives = [{
  name: 'Koperasi Maju Jaya',
  orders: 156,
  value: 45000000
}, {
  name: 'Koperasi Sejahtera',
  orders: 132,
  value: 38000000
}, {
  name: 'Tani Makmur',
  orders: 98,
  value: 28000000
}, {
  name: 'Desa Mandiri',
  orders: 87,
  value: 24000000
}, {
  name: 'Berkah Bersama',
  orders: 65,
  value: 19000000
}];
export function Dashboard() {
  return <div className="space-y-6" data-id="element-478">
      {/* Stats Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-479">
        <StatCard label="Total Pesanan Hari Ini" value="142" trend="12% vs kemarin" icon={ShoppingCart} color="blue" data-id="element-480" />
        <StatCard label="Total Pendapatan" value="Rp 45,2 Juta" trend="8% vs kemarin" icon={DollarSign} color="green" data-id="element-481" />
        <StatCard label="Rata-rata Margin" value="18,5%" trend="2,1%" icon={TrendingUp} color="violet" data-id="element-482" />
        <StatCard label="Koperasi Aktif" value="127" trend="4 baru" icon={Users} color="amber" data-id="element-483" />
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6" data-id="element-484">
        {/* Revenue Chart */}
        <Card className="lg:col-span-2 p-6" data-id="element-485">
          <div className="flex justify-between items-center mb-6" data-id="element-486">
            <div data-id="element-487">
              <h3 className="font-bold text-lg text-slate-800" data-id="element-488">
                Grafik Pendapatan
              </h3>
              <p className="text-sm text-slate-500 mt-1" data-id="element-489">
                Pendapatan 7 hari terakhir
              </p>
            </div>
            <select className="text-sm border-slate-200 rounded-lg text-slate-600 bg-slate-50 px-3 py-2" data-id="element-490">
              <option data-id="element-491">7 Hari Terakhir</option>
              <option data-id="element-492">30 Hari Terakhir</option>
              <option data-id="element-493">3 Bulan Terakhir</option>
            </select>
          </div>
          <div className="h-80" data-id="element-494">
            <ResponsiveContainer width="100%" height="100%" data-id="element-495">
              <LineChart data={revenueData} data-id="element-496">
                <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#E2E8F0" data-id="element-497" />
                <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{
                fill: '#64748B',
                fontSize: 12
              }} dy={10} data-id="element-498" />
                <YAxis axisLine={false} tickLine={false} tick={{
                fill: '#64748B',
                fontSize: 12
              }} tickFormatter={value => `${(value / 1000000).toFixed(1)}Jt`} data-id="element-499" />
                <Tooltip contentStyle={{
                borderRadius: '8px',
                border: 'none',
                boxShadow: '0 4px 6px -1px rgb(0 0 0 / 0.1)'
              }} formatter={(value: number) => [`Rp ${value.toLocaleString('id-ID')}`, 'Pendapatan']} data-id="element-500" />
                <Line type="monotone" dataKey="value" stroke="#2563EB" strokeWidth={3} dot={{
                r: 4,
                fill: '#2563EB',
                strokeWidth: 2,
                stroke: '#fff'
              }} activeDot={{
                r: 6
              }} data-id="element-501" />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </Card>

        {/* Alerts & Actions */}
        <div className="space-y-6" data-id="element-502">
          {/* Alerts Card */}
          <Card className="p-6" data-id="element-503">
            <h3 className="font-bold text-lg text-slate-800 mb-4" data-id="element-504">
              Perlu Tindakan
            </h3>
            <div className="space-y-3" data-id="element-505">
              <button className="w-full flex items-start gap-3 p-3 bg-amber-50 rounded-lg border border-amber-100 hover:bg-amber-100 transition-colors text-left" data-id="element-506">
                <AlertTriangle className="w-5 h-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-507" />
                <div className="flex-1" data-id="element-508">
                  <h4 className="text-sm font-bold text-amber-800" data-id="element-509">
                    MOQ Belum Terpenuhi
                  </h4>
                  <p className="text-xs text-amber-600 mt-1" data-id="element-510">
                    3 grup produk di bawah minimum order quantity
                  </p>
                </div>
              </button>

              <button className="w-full flex items-start gap-3 p-3 bg-red-50 rounded-lg border border-red-100 hover:bg-red-100 transition-colors text-left" data-id="element-511">
                <Package className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" data-id="element-512" />
                <div className="flex-1" data-id="element-513">
                  <h4 className="text-sm font-bold text-red-800" data-id="element-514">
                    Stok Menipis
                  </h4>
                  <p className="text-xs text-red-600 mt-1" data-id="element-515">
                    Indomie Goreng stok kritis (di bawah 50 karton)
                  </p>
                </div>
              </button>

              <button className="w-full flex items-start gap-3 p-3 bg-blue-50 rounded-lg border border-blue-100 hover:bg-blue-100 transition-colors text-left" data-id="element-516">
                <Clock className="w-5 h-5 text-blue-600 flex-shrink-0 mt-0.5" data-id="element-517" />
                <div className="flex-1" data-id="element-518">
                  <h4 className="text-sm font-bold text-blue-800" data-id="element-519">
                    Menunggu Persetujuan
                  </h4>
                  <p className="text-xs text-blue-600 mt-1" data-id="element-520">
                    12 pesanan baru menunggu konfirmasi
                  </p>
                </div>
              </button>
            </div>
          </Card>

          {/* Top Cooperatives */}
          <Card className="p-6" data-id="element-521">
            <h3 className="font-bold text-lg text-slate-800 mb-4" data-id="element-522">
              Koperasi Teratas
            </h3>
            <div className="space-y-3" data-id="element-523">
              {topCooperatives.map((coop, i) => <button key={i} className="w-full flex items-center justify-between hover:bg-slate-50 p-2 rounded-lg transition-colors text-left" data-id="element-524">
                  <div className="flex items-center gap-3 flex-1" data-id="element-525">
                    <span className={`
                      w-7 h-7 rounded-full flex items-center justify-center text-xs font-bold flex-shrink-0
                      ${i === 0 ? 'bg-yellow-100 text-yellow-700' : i === 1 ? 'bg-slate-200 text-slate-700' : i === 2 ? 'bg-orange-100 text-orange-700' : 'bg-slate-100 text-slate-500'}
                    `} data-id="element-526">
                      {i + 1}
                    </span>
                    <div className="flex-1 min-w-0" data-id="element-527">
                      <p className="text-sm font-bold text-slate-900 truncate" data-id="element-528">
                        {coop.name}
                      </p>
                      <p className="text-xs text-slate-500" data-id="element-529">
                        {coop.orders} pesanan
                      </p>
                    </div>
                  </div>
                  <span className="text-xs font-bold text-blue-600 whitespace-nowrap" data-id="element-530">
                    Rp {(coop.value / 1000000).toFixed(1)}Jt
                  </span>
                </button>)}
            </div>
          </Card>
        </div>
      </div>
    </div>;
}